import usePopupScrollLock from "./usePopupScrollLock";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import ReferenceRewardPopup from "./ReferenceRewardPopup";

export default function ReferenceInviteBonusPopup({ onClose, covered = false, initialStep = "offer", rewardAmount = 387.10, claimedTotal = 15520, targetAmount = 388 }) {
  // Screenshot presentation values; a reward service must supply account values.
  const [step, setStep] = useState(initialStep);
  const progressRef = useRef(null);
  const [tasksOpen, setTasksOpen] = useState(false);
  const [infoTab, setInfoTab] = useState("TASK");
  const remaining = Math.max(0, targetAmount - rewardAmount);
  const progress = Math.min(100, Math.max(0, rewardAmount / targetAmount * 100));
  const [seconds, setSeconds] = useState(28 * 86400 + 21 * 3600 + 58 * 60 + 39);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const clock = `${Math.floor(seconds / 86400)} Days ${String(Math.floor(seconds % 86400 / 3600)).padStart(2, "0")}:${String(Math.floor(seconds % 3600 / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;
  const navigate = useNavigate();
  usePopupScrollLock();

  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape" && !tasksOpen && !covered) onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
    };
  }, [onClose, tasksOpen, covered]);

  const openInvitePage = () => {
    onClose("leave");
    navigate("/member?tab=invite");
  };

  return createPortal(
    <>
    <div
      className="reference-invite-bonus-overlay"
      aria-hidden={covered || undefined}
      inert={covered}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !tasksOpen && !covered) onClose();
      }}
    >
      <div className={`reference-invite-bonus reference-invite-${step}`} role="dialog" aria-modal={!tasksOpen && !covered} aria-hidden={tasksOpen || undefined} inert={tasksOpen} aria-label="Invite friends bonus">
        {step === "offer" ? <div className="reference-invite-bonus-card">
          <img src="/assets/bdtwin/invite-treasure-art.png" alt="বন্ধুদের আমন্ত্রণ জানান, ট্রেজার বক্স খুলে পুরস্কার নিন" />
          <button type="button" className="reference-invite-bonus-cta" onClick={() => setStep("congratulations")}>
            Get free bonus
          </button>
        </div> : step === "congratulations" ? (
          <div className="reference-invite-result">
            <img className="reference-invite-chest" src="/assets/images/temu-history-box.5cd73118.gif" alt="Golden treasure chest" />
            <h2>Congratulations!</h2>
            <hr />
            <h3>Won a free reward</h3>
            <div className="reference-invite-amount">৳ {Math.floor(rewardAmount)}<small>.{rewardAmount.toFixed(2).split(".")[1]}</small></div>
            <p>Can be claim once accumulated to ৳ {targetAmount}</p>
            <button type="button" className="reference-invite-bonus-cta" onClick={() => setStep("progress")}>Complete tasks to claim bonuses</button>
          </div>
        ) : (
          <div className="reference-invite-progress-panel" ref={progressRef}>
            <h2>বন্ধুদের আমন্ত্রণ জানান, ট্রেজার বক্স..</h2>
            <div className="reference-invite-podium">
              <img src="/assets/images/temu-history-box.5cd73118.gif" alt="Golden treasure chest" />
              <strong>৳ {claimedTotal.toLocaleString("en-US", { minimumFractionDigits: 2 })} claimed</strong>
            </div>
            <div className="reference-invite-progress-card">
              <div className="reference-invite-expiry">◷ {clock} &nbsp; Expired</div>
              <div className="reference-invite-amount-row">
                <div className="reference-invite-amount">৳ {Math.floor(rewardAmount)}<small>.{rewardAmount.toFixed(2).split(".")[1]}</small></div>
                <button type="button" className="reference-invite-soon" aria-label="View voucher requirements" onClick={() => { if (progressRef.current) progressRef.current.scrollTop = 0; setTasksOpen(true); }}>Claiming soon</button>
              </div>
              <div className="reference-invite-meter" role="progressbar" aria-label="Treasure reward progress" aria-valuenow={Number(progress.toFixed(2))} aria-valuemin={0} aria-valuemax={100}><i style={{ width: `${progress}%` }} /></div>
              <p>Only ৳ {remaining.toFixed(2)} away from claim to wallet</p>
              <button type="button" className="reference-invite-bonus-cta" onClick={openInvitePage}>Invite friends to speed up claim</button>
            </div>
            <nav className="reference-invite-task-head" aria-label="Treasure information">
              {["TASK", "Description", "Task Details"].map(tab => (
                <button
                  key={tab}
                  type="button"
                  className={infoTab === tab ? "active" : ""}
                  aria-pressed={infoTab === tab}
                  onClick={() => setInfoTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </nav>
            <div className="reference-invite-task-body">
              {infoTab === "Description" ? (
                <div className="reference-invite-info">
                  <p>chorki বন্ধুদের আমন্ত্রণ জানিয়ে ট্রেজার বক্স খোলার ইভেন্ট চালু করেছে।</p>
                  <p>১. প্রতিবার একজন বন্ধুকে আমন্ত্রণ জানালে আপনি পুরস্কারের জন্য একবার ড্র করার সুযোগ পাবেন। আপনার মোট পুরস্কার ৳ {targetAmount} হলে সম্পূর্ণ অর্থ উত্তোলন করতে পারবেন।</p>
                  <p>২. এই ইভেন্টের বোনাস উত্তোলনের জন্য ৫ গুণ বৈধ বেটিং সম্পন্ন করতে হবে।</p>
                </div>
              ) : infoTab === "Task Details" ? (
                <div className="reference-invite-task-history"><div><span>Time</span><span>Reward</span></div><p>No matched data found</p></div>
              ) : (
                <article className="reference-invite-task-card">
                  <img src="/assets/bdtwin/wheel/invite-people.png" alt="" />
                  <div>
                    <strong>Specific Achievement - Invite Friends to Register</strong>
                    <p>After player claim the initial points, for every <b>1</b> qualified friends invited, player can claim <b>1</b> random rewards.</p>
                  </div>
                  <button type="button" className="reference-invite-task-action" aria-label="Open invite task" onClick={openInvitePage} />
                </article>
              )}
            </div>
          </div>
        )}
        <button type="button" className="reference-invite-bonus-close" aria-label="Close invite bonus" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
    {tasksOpen && <ReferenceRewardPopup initialTask onClose={(reason) => { setTasksOpen(false); if (reason === "deposit" || reason === "betting") onClose("leave"); }} />}
    </>,
    document.body,
  );
}
